import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import React from "react";
import styled from "styled-components";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { ImageCreateEdit } from "../../../../../components/ImageCreateEdit";
import { User } from "../../../../../model/user/User";
import { Rounded } from "../../../../../theme/Rounded";

const Circle = styled.span<{ $size: string }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: ${Rounded.circle};
  overflow: hidden;
  background-color: ${({ theme }) => theme.sub};

  svg,
  img {
    width: 100%;
    height: 100% !important;
  }

  img {
    object-fit: cover !important;
    border-radius: ${Rounded.circle};
  }
`;

type Props = {
  // Partial: assignees arrive populated with only a few fields
  user?: Partial<Pick<User, "name" | "picture">>;
  size?: string;
};

export const WAUserAvatar: React.FC<Props> = ({ user, size = "1.5rem" }) => (
  <Circle $size={size}>
    {user?.picture ? (
      <ImageCreateEdit src={user.picture} alt={user.name} />
    ) : (
      <AtiraIcon icon={faUserCircle} color="main" />
    )}
  </Circle>
);
